import { render, staticRenderFns } from "./animated-img.vue?vue&type=template&id=3a7b0381"
import script from "./animated-img.vue?vue&type=script&lang=js"
export * from "./animated-img.vue?vue&type=script&lang=js"
import style0 from "./animated-img.vue?vue&type=style&index=0&id=3a7b0381&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})


/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Scroll from 'vuetify/lib/directives/scroll'
installDirectives(component, {Scroll})
